var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChildhood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4146 73.6272L64.0123 77.8954L79.4154 101L85.8177 96.7318L70.4146 73.6272Z",
    fill: "#FFD44F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5325 25.6946C57.3996 25.6946 55.6852 27.4289 55.6852 29.5419C55.6852 31.6549 57.4195 33.3892 59.5325 33.3892C61.6456 33.3892 63.3798 31.6549 63.3798 29.5419C63.3798 27.4289 61.6456 25.6946 59.5325 25.6946ZM59.5325 41.1037C53.1536 41.1037 47.9907 35.9208 47.9907 29.5618C47.9907 23.2028 53.1536 18 59.5325 18C65.9115 18 71.0744 23.1829 71.0744 29.5419C71.0744 35.9009 65.8915 41.0837 59.5325 41.0837",
    fill: "#FFD44F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6399 73.6155L33.2368 96.7201L39.6391 100.988L55.0422 77.8837L48.6399 73.6155Z",
    fill: "#FFD44F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0744 79.5965H47.9707V55.0376L27 44.5522L30.4486 37.655L55.6653 50.2734V71.9019H63.3798V50.2734L88.6165 37.655L92.0451 44.5522L71.0744 55.0376V79.5965Z",
    fill: "#FFD44F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildhood);
export default __webpack_public_path__ + "static/media/childhood.44d94b667f388ea8d267a296dc4a8f0b.svg";
export { ForwardRef as ReactComponent };